import { Icon, InfoIconTooltip } from '@components/index';
import { IST_TIMEZONE } from '@constants/date';
import { NULLDATE } from '@constants/generic';
import { SettlementDetails } from '@types';
import { formatISODate } from '@utils/date';

import theme from '../../../../../themes/colors';

const SettlementDetailsTooltip = ({
  id,
  settlementDetails
}: {
  id: string;
  settlementDetails: SettlementDetails[];
}) => {
  // find latest date from settlement details
  const latestDate = settlementDetails.reduce(
    (latest, current) =>
      new Date(current.settled_at) > new Date(latest)
        ? current.settled_at
        : latest,
    settlementDetails[0].settled_at
  );

  return (
    <div className="flex items-center gap-2">
      <div>
        {formatISODate({
          date: latestDate,
          format: 'dd-mm-yyyy',
          timeZone: IST_TIMEZONE
        })}
      </div>
      <InfoIconTooltip id={`${id}-settledOn`}>
        {[...settlementDetails].reverse().map((item, index) => (
          <div className="flex items-center gap-2 text-white">
            <div className="flex flex-col items-start">
              {item.settled_at && item.settled_at !== NULLDATE ? (
                <div className="flex items-center gap-2">
                  <Icon name="settled_on_green" size="24" />
                  <div className="flex flex-col items-start">
                    <div className="flex items-center">
                      <Icon name="rupee" size="12" fill={theme.theme} />
                      {item.amount}
                    </div>
                    <div className="flex min-w-max items-center">
                      Settled on{' '}
                      {formatISODate({
                        date: item.settled_at,
                        format: 'dd-mm-yyyy',
                        timeZone: IST_TIMEZONE
                      })}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="my-2 flex items-center gap-2">
                  <Icon name="settled_on_blue" size="24" />
                  <div>
                    <div className="flex items-center">
                      <Icon name="rupee" size="12" fill={theme.theme} />
                      {item.amount}
                    </div>
                    <div className="flex min-w-max items-center">
                      Processing
                    </div>
                  </div>
                </div>
              )}
              {index !== settlementDetails.length - 1 && (
                <div className=" ml-2.5 h-6 w-px border-l border-dashed border-primary" />
              )}
            </div>
          </div>
        ))}
      </InfoIconTooltip>
    </div>
  );
};

export default SettlementDetailsTooltip;
